import {
  clearNipTestState,
  initiateTest,
  runOutwardTest,
  submitOutwardTest,
} from "../../../../redux/Actions/OutwardTestActions";

export function checkSuccess(
  state,
  test,
  runNESuccess,
  runFTSuccess,
  runSQSuccess
) {
  return state.stepIndex !== test.id &&
    ((test.type === "name-enquiry" && !runNESuccess) ||
      (test.type === "funds-transfer" && !runFTSuccess) ||
      (test.type === "transfer-status-query" && !runSQSuccess))
    ? "nip-outward-box2"
    : "nip-outward-box";
}

export function checkSuccess2(test, runNESuccess, runFTSuccess, runSQSuccess) {
  return (test.type === "name-enquiry" && !runNESuccess) ||
    (test.type === "funds-transfer" && !runFTSuccess) ||
    (test.type === "transfer-status-query" && !runSQSuccess)
    ? "check2"
    : "check";
}

export function checkSuccess3(test, runNESuccess, runFTSuccess, runSQSuccess) {
  return (
    (test.type === "name-enquiry" && runNESuccess === true) ||
    (test.type === "funds-transfer" && runFTSuccess === true) ||
    (test.type === "transfer-status-query" && runSQSuccess === true)
  );
}

export function checkSuccess4(test, runNESuccess, runFTSuccess, runSQSuccess, error) {
  return (
    (test.type === "name-enquiry" && runNESuccess === false && error) ||
    (test.type === "funds-transfer" && runFTSuccess === false && error) ||
    (test.type === "transfer-status-query" && runSQSuccess === false && error)
  );
}

export function reduxActions() {
  return (dispatch) => ({
    clearNipTestState: () => dispatch(clearNipTestState()),
    initiateTest: (type, payload) => dispatch(initiateTest(type, payload)),
    runEachTest: (name, payload) => dispatch(runOutwardTest(name, payload)),
    submitOutwardTest: (payload) => dispatch(submitOutwardTest(payload)),
  });
}

export function reduxState() {
  return (state) => {
    return {
      isInitiatingTest: state.outwardTest.isInitiatingTest,
      initiateSuccess: state.outwardTest.initiateSuccess,
      testItems: state.outwardTest.testItems && state.outwardTest.testItems.data,
      nameEnquiry: state.outwardTest.sendNameEnquiry,
      fundTransfer: state.outwardTest.sendFundTransfer,
      statusQuery: state.outwardTest.sendStatusQuery,
      isRunningNE: state.outwardTest.isSendingNameEnquiryValues,
      isRunningFT: state.outwardTest.isSendingFundTransferValues,
      isRunningSQ: state.outwardTest.isSendingStatusQueryValues,
      runNESuccess: state.outwardTest.sendNameEnquiryValuesSuccess,
      runFTSuccess: state.outwardTest.sendFundTransferValuesSuccess,
      runSQSuccess: state.outwardTest.sendStatusQueryValuesSuccess,
      isSubmitting: state.outwardTest.isSubmitting,
      submitTestSuccess: state.outwardTest.submitTestSuccess,
      error: state.outwardTest.error,
    };
  };
}

export function checkString(data) {
  const string = data;
  const newString = string && string.split("&").join("");
  return newString
}
